var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#EFEFEF",
    stroke: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1893_21318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 11.6662L14.3332 8.99955M6.6665 19.3329L8.92275 19.0822C9.19841 19.0516 9.33624 19.0362 9.46507 18.9945C9.57936 18.9575 9.68814 18.9053 9.78843 18.8391C9.90147 18.7646 9.99953 18.6665 10.1957 18.4704L18.9999 9.66622C19.7362 8.92984 19.7362 7.73593 18.9999 6.99955C18.2635 6.26317 17.0696 6.26317 16.3332 6.99955L7.52899 15.8037C7.33287 15.9999 7.23481 16.0979 7.16026 16.211C7.09413 16.3113 7.04185 16.42 7.00485 16.5343C6.96314 16.6632 6.94783 16.801 6.9172 17.0766L6.6665 19.3329Z",
    stroke: "#636363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1893_21318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/editPencil.6e31ef0fa00145958ab98b2164974286.svg";
export { ForwardRef as ReactComponent };